import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useCustomSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const addSearchParam = useCallback(
    (key: string, value: string) => {
      setSearchParams((prev) => {
        if (prev.get(key) === value) return prev;
        const next = new URLSearchParams(prev);
        next.set(key, value);
        return next;
      });
    },
    [setSearchParams]
  );

  const deleteSearchParam = useCallback(
    (key: string) => {
      setSearchParams((prev) => {
        if (!prev.has(key)) return prev;
        const next = new URLSearchParams(prev);
        next.delete(key);
        return next;
      });
    },
    [setSearchParams]
  );

  return { searchParams, addSearchParam, deleteSearchParam };
};
